import React from 'react';
import AnimatedSection from './AnimatedSection';

const About = () => {
  return (
    <section
      id="ueber-alex"
      data-testid="about-section"
      className="py-24 md:py-32 bg-brand-dark relative overflow-hidden"
    >
      {/* Background image with parallax */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage: 'url(/img/background/massage-spa-1.jpg)',
          backgroundAttachment: 'fixed',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/95 to-brand-dark/90" />

      {/* Decorative elements */}
      <div className="absolute top-20 right-20 w-64 h-64 border border-brand-gold/10 rounded-full" />
      <div className="absolute bottom-20 left-10 w-32 h-32 border border-brand-gold/10 rounded-full" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Visual side */}
          <AnimatedSection direction="left" className="relative">
            <div className="relative">
              {/* Main image */}
              <div className="relative rounded-3xl overflow-hidden shadow-2xl img-zoom">
                <img
                  src="/img/lymphatic-massage.jpg"
                  alt="Premium Massage"
                  className="w-full aspect-[4/5] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/40 to-transparent" />
              </div>

              {/* Floating card */}
              <div className="absolute -bottom-6 -right-6 lg:-right-12 bg-brand-gold text-brand-dark p-6 rounded-2xl shadow-2xl animate-pulse-glow">
                <div className="font-marcellus text-4xl">10+</div>
                <div className="font-work text-sm">Jahre Erfahrung</div>
              </div>

              {/* Logo overlay */}
              <div className="absolute top-6 left-6 w-16 h-16 glass rounded-full flex items-center justify-center">
                <img
                  src="/logo.png"
                  alt="Logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
            </div>
          </AnimatedSection>

          {/* Content side */}
          <div className="text-brand-light">
            <AnimatedSection direction="right">
              <span className="inline-flex items-center gap-2 font-work text-sm text-brand-gold uppercase tracking-widest mb-4">
                <span className="w-8 h-px bg-brand-gold" />
                Über mich
              </span>
              
              <h2 className="font-marcellus text-4xl md:text-5xl lg:text-6xl mb-6">
                Ihr Weg zur<br />
                <span className="gradient-text">Körperharmonie</span>
              </h2>
            </AnimatedSection>
            
            <AnimatedSection direction="right" delay={100}>
              <p className="font-work text-brand-light/70 text-lg leading-relaxed mb-6">
                Mit über einem Jahrzehnt Erfahrung im Bereich Wellness und Massage biete ich Ihnen 
                eine einzigartige Kombination aus traditionellen Techniken und modernen Ansätzen. 
                Jede Behandlung wird individuell auf Ihre Bedürfnisse abgestimmt.
              </p>
              
              <p className="font-work text-brand-light/60 leading-relaxed mb-6">
                Die Sitzungen finden bei Ihnen zu Hause statt, ich bringe alles Nötige mit. 
                In einer ruhigen, stilvollen Atmosphäre können Sie den Alltag hinter sich lassen 
                und sich ganz der Entspannung hingeben. Ihr Wohlbefinden steht bei mir im Mittelpunkt.
              </p>
            </AnimatedSection>

            {/* CTA */}
            <AnimatedSection delay={300}>
              <a
                href="#buchung"
                data-testid="about-cta"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#buchung')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="group inline-flex items-center gap-3 px-8 py-4 bg-brand-gold text-brand-dark font-work font-semibold rounded-full hover:bg-white transition-all duration-300 magnetic-btn"
              >
                Termin vereinbaren
                <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </AnimatedSection>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
